import { useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

export function useUserName(): string {
  const [userName, setUserName] = useState<string>("");
  const auth = getAuth();

  useEffect(() => {
    const storedName = localStorage.getItem('rawpa_user_name');
    if (storedName) {
      setUserName(storedName);
    }
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const displayName = user.displayName || user.email?.split('@')[0] || 'User';
        setUserName(displayName);
        localStorage.setItem('rawpa_user_name', displayName);
      }
    });
    return () => unsubscribe();
  }, []);

  return userName;
} 